exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*\nStylesheet for the notification component.\n@author Eduardo Parducci\n*/\n.md-snackbar[data-v-41ba2ce1] {\n  bottom: 100px !important;\n}\n.md-button[data-v-41ba2ce1] {\n  color: white !important;\n  font-weight: 600 !important;\n}\n", "", {"version":3,"sources":["/home/gitlab-runner/builds/b21bf5d0/0/mkz/werner-frontend/src/components/app/notification/notification.css"],"names":[],"mappings":"AAAA;;;EAGE;AAEF;EACE,yBAAyB;CAC1B;AACD;EACE,wBAAwB;EACxB,4BAA4B;CAC7B","file":"notification.css","sourcesContent":["/*\nStylesheet for the notification component.\n@author Eduardo Parducci\n*/\n\n.md-snackbar {\n  bottom: 100px !important;\n}\n.md-button {\n  color: white !important;\n  font-weight: 600 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41ba2ce1","scoped":true,"hasInlineConfig":false}!./src/components/app/notification/notification.css
// module id = pEKF
// module chunks = 1